import React from 'react';
import {
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from '@exiftrator/shared/components/ui';

const EMPTY_SELECT_VALUE = '__none__';

function PresetFieldValueInput({ field, value, onChange, disabled = false }) {
  const normalizedValue = value ?? '';

  if (field.type === 'textarea') {
    return (
      <Textarea
        value={normalizedValue}
        onChange={(event) => onChange(event.target.value)}
        className="min-h-20"
        placeholder={`Enter ${field.label.toLowerCase()}...`}
        disabled={disabled}
      />
    );
  }

  if (field.type === 'select') {
    const selectValue = normalizedValue === '' ? EMPTY_SELECT_VALUE : String(normalizedValue);

    return (
      <Select
        value={selectValue}
        disabled={disabled}
        onValueChange={(nextValue) => {
          onChange(nextValue === EMPTY_SELECT_VALUE ? '' : nextValue);
        }}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="None" />
        </SelectTrigger>
        <SelectContent align="start">
          <SelectItem value={EMPTY_SELECT_VALUE}>None</SelectItem>
          {field.options?.map((option) => (
            <SelectItem key={option.value} value={String(option.value)}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  if (field.type === 'number' || field.type === 'gps-coordinate') {
    return (
      <Input
        type="number"
        step="any"
        value={normalizedValue}
        onChange={(event) => onChange(event.target.value)}
        placeholder={field.type === 'gps-coordinate' ? '0.0000000' : `Enter ${field.label.toLowerCase()}`}
        disabled={disabled}
      />
    );
  }

  if (field.type === 'datetime-local') {
    return (
      <Input
        type="datetime-local"
        value={normalizedValue}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
      />
    );
  }

  return (
    <Input
      type="text"
      value={normalizedValue}
      onChange={(event) => onChange(event.target.value)}
      placeholder={`Enter ${field.label.toLowerCase()}`}
      disabled={disabled}
    />
  );
}

export default PresetFieldValueInput;
